import { FC } from "react";

import Icons from "@app/assets/Icons";

import "./index.scss";

interface ToggleProps {
    heading?: string;
    isActive: boolean;
    onToggle?: (_val: boolean) => void;
    display?: string;
    isDisabled?: boolean;
}
const Toggle: FC<ToggleProps> = ({ isActive, onToggle, isDisabled, display, heading: name }) => {
    const onClick = () => {
        onToggle?.(!isActive);
    };

    const toggleClass = `${isActive ? "custom-toggle" : "custom-toggle--off"} ${
        isDisabled ? " custom-toggle--disabled" : ""
    }`;

    return (
        <>
            <h6 className='margin-bottom'>{name}</h6>
            <div className={toggleClass} onClick={() => !isDisabled && onClick()}>
                {isActive ? (
                    <>
                        <span className={"custom-toggle__on"}>{display}</span>
                        <img
                            className={"custom-toggle__icon-on"}
                            src={Icons.ToggleTickIcon}
                            alt='Toggle On'
                        />
                    </>
                ) : (
                    <>
                        <img
                            className={"custom-toggle__icon-off"}
                            src={Icons.ToggleCrossIcon}
                            alt='Toggle Off'
                        />
                        <span className={"custom-toggle__off"}>{display} </span>
                    </>
                )}
            </div>
        </>
    );
};
export default Toggle;
